import { gql } from '@apollo/client';

export const GetUserAgents = gql`
    query getUserAgents {
        getUserAgents {
            id
            callService
            agents {
                id
                name
                title
                phoneNumber
                priceId
                userSubscriptionPremium
                userSubscriptionCancelDate
                hostedInvoiceUrl
                callTransferActive
                googleCalendar
                fillerAudio {
                    active
                }
                callTransfer {
                    id
                    phoneNumber
                    instructionBeforTransfer
                    beforTransferingMsg
                    callerIdStatus
                }
                terminateCallAction {
                    active
                    code
                }
                textNotification {
                    active
                    phoneNumber
                }
                emailNotification {
                    active
                    email1
                    email2
                    email3
                }
                initialMessage
                trainingGuide
                callService
                timeZone
            }
        }
    }
`;
